import { get } from 'lodash'
import { isAssessorManagementEnabledForActivity } from '../../helpers/assessorHelper'


export const asyncValidate = (val, dispatch, props) => {
  const { values } = props
  const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(val)
  const setupAssessorId = get(values, 'setupAssessorId')
  const defaultResponse = { body: { available: false } }
  const email = get(values, 'assessorEmail')
  const orgId = get(props, 'dashboard.awards.awards.data.organization.id')
  const activityCategoryId = get(values, 'helpers.subcategory')

    if (!isAssessorManagementEnabled || setupAssessorId !== 0) {
      return new Promise(resolve => resolve())
    }

  const promises = Promise.all([
    props.checkAssessorEmailAvailability(email, orgId, activityCategoryId).catch(() => defaultResponse),
  ])

  return promises
    .then(body => {
      if (body && body[0] && !get(body[0], 'body.available')) {
        const bodyObj = get(body[0], 'body')

        let assessor = ''

        get(bodyObj, 'assessorList').forEach(a => {
          assessor += get(a, 'name') + ' '
        })
        // eslint-disable-next-line
        throw {
          assessorEmail:
            {
              text: `Assessor ${assessor} already exists, select him/her from the list.`,
              intlKey: 'errors.assessor_already_exists'
            }
        }
      }
    })
}